import { render, staticRenderFns } from "./VLoadFailed.vue?vue&type=template&id=5df0b360&"
import script from "./VLoadFailed.vue?vue&type=script&lang=js&"
export * from "./VLoadFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports